export default {
  title: {
    label: 'Titel',
    required: true,
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Tragen Sie hier den Titel des museumspädagogischen Programms ein. Verwenden Sie dazu einen möglichst aussagekräftigen und griffigen Titel, der das Thema umschreibt.'
  },
  duration: {
    label: 'Dauer',
    required: true,
    type: 'number',
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Tragen Sie hier die Dauer des museumspädagogischen Programms in Minuten ein (mind. 10 Minuten). Es kann keine Zeitspanne eingetragen werden.'
  },
  maxParticipants: {
    label: 'Maximale Teilnehmer',
    required: true,
    type: 'number',
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Tragen Sie hier die maximale Anzahl der Teilnehmer ein. Beachten Sie: In Bayern gilt pro Klasse die Obergrenze von 35 Schülern.'
  },
  meetingPoint: {
    label: 'Treffpunkt',
    required: true,
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Ist Ihr Treffpunkt mit der Schulklasse nicht der Haupteingang des Museums, können Sie hier konkrete Angaben zum Treffpunkt machen (z. B. Am Parkplatz vor dem Museum).'
  },
  description: {
    label: 'Beschreibung',
    required: true,
    type: 'number',
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Formulieren Sie hier einen kurzen Text, der Ihr museumspädagogisches Programm näher erläutert, nach folgender Struktur: <ul><li>Überblick über die Veranstaltung, </li><li>Ablauf, </li><li>Alleinstellungsmerkmal.</li></ul> Inkl. Leerzeichen sollte er zwischen 100 und 1000 Zeichen umfassen. Verwenden Sie aussagekräftige Schlagwörter, so dass der Eintrag auch für Nutzer, die über Suchmaschinen recherchieren, auf ndbar ist.'
  },
  expireAt: {
    label: 'Läuft aus am',
    required: true,
    type: 'date',
    section: 'general',
    // eslint-disable-next-line max-len
    info: 'Die Laufzeit der MUSbi-Veranstaltungen beträgt maximal 4 Jahre. Nach Ablauf der Frist können die Programme überprüft und neu eingestellt werden.'
  },

  schools: {
    label: 'Schule',
    section: 'reference',
    // eslint-disable-next-line max-len
    info: 'Wählen Sie hier die Schulart aus dem Dropdown-Menü aus, für die Ihr museumspädagogisches Programm infrage kommt. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.',
    note: '(Mehrfachauswahl möglich)'
  },
  curriculums: {
    label: 'Lehrplanbezug',
    section: 'reference',
    // eslint-disable-next-line max-len
    info: 'Geben Sie hier den Lehrplanbezug Ihres museumspädagogischen Programms an.<br /><br />Beachten Sie die Formatvorgabe:<br /><br /><i>Schulart Doppelpunkt Abkürzung des Fachs ohne Leerzeichen Jahrgangsstufe Leerzeichen Gliederungszahl des Lehrplanabschnitts</i> (z. B. Grundschule: HSU3/4 3.2). Fächer bitte durch Strichpunkt trennen. Die Lehrpläne können unter <a href="http://www.lehrplanplus.bayern.de/">www.lehrplanplus.bayern.de</a> eingesehen werden.'
  },
  grades: {
    label: 'Jahrgangsstufe',
    section: 'reference',
    // eslint-disable-next-line max-len
    info: 'Bitte geben Sie maximal fünf aufeinanderfolgende Jahrgangsstufen ein. Sollte sich das Programm in ähnlicher Form auch für weitere Jahrgangsstufen eignen, geben Sie dies bitte als eigenständiges Programm ein. Sie können den Namen des Programms beibehalten, ergänzen Sie aber bitte z.B. „1.-4. Klasse“, „5.-8. Klasse“. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.',
    note: '(Mehrfachauswahl möglich)'
  },
  subjects: {
    label: 'Schulfächer',
    section: 'reference',
    // eslint-disable-next-line max-len
    info: 'Wählen Sie die Schulfächer aus, für die Ihr museumspädagogisches Programm geeignet ist. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.',
    note: '(Mehrfachauswahl möglich)'
  },
  languages: {
    label: 'Sprachen',
    section: 'reference',
    // eslint-disable-next-line max-len
    info: 'Bitte geben Sie an, in welchen Sprachen Ihr museumspädagogisches Programm verfügbar ist. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.',
    note: '(Mehrfachauswahl möglich)'
  },

  bookingStart: {
    label: 'buchbar von',
    required: true,
    type: 'date',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Bieten Sie Ihr Programm ganzjährig an, wäre hier der Januar einzutragen. <br />Falls das Programm nur in bestimmten Monaten des Jahres gebucht werden kann, geben Sie hier bitte den frühest möglichen Zeitpunkt an.'
  },
  bookingEnd: {
    label: 'buchbar bis',
    required: true,
    type: 'number',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Bieten Sie Ihr Programm ganzjährig an, wäre hier der Dezember einzutragen. <br />Falls das Programm nur in bestimmten Monaten des Jahres gebucht werden kann, geben Sie hier bitte den spätest möglichen Zeitpunkt an.'
  },
  bookableOutOfSeason: {
    label: 'ja, außerhalb der Museumssaison buchbar',
    type: 'checkbox',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: ''
  },
  bookableOutOfOpeningTimes: {
    label: 'ja, außerhalb der Museumsöffnungszeiten buchbar',
    type: 'checkbox',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Setzen Sie einen Haken, wenn Ihr museumspädagogisches Programm unabhängig von den Museumsöffnungszeiten buchbar ist.'
  },
  days: {
    label: 'an folgenden Wochentagen',
    type: 'number',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Wählen Sie aus dem Dropdown-Menü aus, an welchen Wochentagen Ihr museumspädagogisches Programm buchbar ist. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.',
    note: '(Mehrfachauswahl möglich)'
  },
  temporarilyNotBookable: {
    label: 'Temporär nicht buchbar',
    type: 'checkbox',
    section: 'booking',
    // eslint-disable-next-line max-len

  },
  temporarilyNotBookableReason: {
    label: 'Grund',
    section: 'booking',
  },
  generalPrice: {
    required: true,
    type: 'number',
    label: 'Pauschalbetrag',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Bitte geben Sie hier den Betrag ein, den Ihr museumspädagogisches Programm pauschal kostet. Bitte beachten Sie, dass Sie entweder einen Pauschalbetrag angeben können oder im nächsten Feld einen Preis pro Schüler in Kombination mit einem Mindestbetrag festlegen. Ein doppelter Eintrag ist nicht möglich.'
  },
  minPrice: {
    label: 'Mindestbetrag',
    required: true,
    type: 'number',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Bitte geben Sie hier den Mindestbetrag ein, der für Ihr museumspädagogisches Programm bezahlt werden muss. Diese Angabe ist wichtig, da Schulklassen keine einheitlichen Schülerzahlen haben. Bitte beachten Sie, dass Sie auch einen Betrag pro Schüler angeben müssen.'
  },
  costsByPerson: {
    label: 'Preis pro Schüler',
    required: true,
    type: 'number',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Falls Sie sich für diese Variante entschieden haben, geben Sie hier bitte den Betrag ein, den jeder Schüler für die Teilnahme an Ihrem museumspädagogischen Programm zu entrichten hat. Bitte beachten Sie, auch einen Mindestbetrag anzugeben, da Schulklassen keine einheitlichen Schülerzahlen haben.'
  },
  materialCosts: {
    label: 'Materialkosten pro Schüler',
    required: true,
    type: 'number',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Setzen Sie den Haken, wenn Lehrkräfte bei Vorbesuchen keinen Eintritt bezahlen müssen.'
  },
  specialConditionsForRemedialClasses: {
    label: 'Gesonderte Konditionen für Förderklassen',
    type: 'checkbox',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Setzen Sie den Haken, wenn für Förderklassen gesonderte Konditionen gelten.'
  },
  freeEntryForTeachersAtPrevisit: {
    label: 'Freier Eintritt für Lehrkräfte bei Vorbesuchen',
    type: 'checkbox',
    section: 'booking',
    // eslint-disable-next-line max-len
    info: 'Setzen Sie den Haken, wenn Lehrkräfte bei Vorbesuchen keinen Eintritt bezahlen müssen.'
  },

  materials: {
    label: 'Materialien',
    type: 'number',
    section: 'material',
    // eslint-disable-next-line max-len
    info: 'Geben Sie hier diejenigen Materialien und deren Anzahl an, die bei Ihrem museumspädagogischen Programm zum Einsatz kommen. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen. </br>Das Dropdown-Menü enthält lediglich die gängisten museumspädagogischen Materialien. Es kann durachaus vorkommen, dass im Programm eingesetzte Materialien hier nicht vorgehalten werden.',
    note: '(und Anzahl)'
  },
  methods: {
    label: 'Methoden',
    type: 'number',
    section: 'material',
    // eslint-disable-next-line max-len
    info: 'Geben Sie hier die Methoden an, die bei Ihrem museumspädagogischen Programm zum Einsatz kommen. Die einzelnen Methoden sind in der Hilfe oder auf den Methodenkärtchen beschrieben. <br />Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen. Beachten Sie: In diesem Feld sind lediglich die Methoden anzugeben, die auch in den Methodenkärtchen zu  nden sind. Natürlich sind auch weitere Methoden erwünscht, sie werden im Zuge der Standardisierung der MUSbi-Angebote jedoch hier nicht vermerkt.',
    note: '(Mehrfachauswahl möglich)'
  },

  links: {
    label: 'PDF-Dateien',
    section: 'media',
    // eslint-disable-next-line max-len
    info: 'Durch Anklicken der Schaltfäche „Dateien auswählen“ können Sie PDF-Dateien(z. B. Programmflyer) exklusiv zu diesem museumspädagogischen Programm hochladen. Es können mehrere Dateien hochgeladen werden. Bitte achten Sie auf die Dateigröße (max. 1 MB pro Datei) und eine websichere Benennung (keine Leeroder Sonderzeichen, keine Umlaute). <br />Bitte geben Sie zu jedem PDF stets eine aussagekräftige Beschreibung mit an, da diese der spätere Anzeigename für das PDF ist. <br />Für die Wahrung der Urheberund Persönlichkeitsrechte ist das jeweilige Museum verantwortlich.',
    note: '(Mehrfachauswahl möglich)'
  },
  media: {
    label: 'Bilder',
    section: 'media',
    // eslint-disable-next-line max-len
    info: 'Durch Anklicken der Schalt äche „Dateien auswählen“ können Sie Bilder (JPG, PNG) zu Ihrem museumspädagogischen Programm hochladen. Es können mehrere Bilder hochgeladen werden. Bitte achten Sie auf die Bildgröße (minimal 1024 x 768 Pixel) sowie die Dateigröße (max. 1 MB) und eine websichere Benennung (keine Leeroder Sonderzeichen, keine Umlaute). Bitte geben Sie zu jedem Bild stets eine aussagekräftige Beschreibung mit an, da diese später für die Nutzer sichtbar ist. Über die Checkbox „als Bannerbild verwenden“ können Sie bei mehreren Bildern das Hauptbild auswählen. Für die Wahrung der Urheberund Persönlichkeitsrechte ist das jeweilige Museum verantwortlich.',
    note: '(Mehrfachauswahl möglich)'
  },

  hostelUrl: {
    label: 'Jugendherberge',
    placeholder: 'http://url-der-jugendherberge.de',
  },
}



// WEBPACK FOOTER //
// ./src/program/fieldSpecs.js